import { useBackend } from "../../services";

export const useGetArtistProducts = () => {
  const { get } = useBackend();
  const getArtistProducts = () => get("products/artists");
  return { getArtistProducts };
};
